import { render } from "./ArrowRight.vue?vue&type=template&id=59a4c123"
const script = {}
script.render = render

export default script